import React, { useContext } from 'react';
import gql from 'graphql-tag';
import { Query } from 'react-apollo';
import { useParams } from 'react-router-dom';
import { AccountContext } from '../../../../components/AccountContext';
import Detail from './components/Detail';
import { growlErrors } from '../../../../utils/NotificationUtil';
import { Loading } from '../../../../components/Loading';
import { NotificationContext } from '../../../../components/GrowlNotifications';

const SURVEY_TEMPLATE_QUERY = gql`
  query($accountId: ID!, $tempId: ID!, $first: Int) {
    account(id: $accountId) {
      id
      template: surveyTemplate(id: $tempId) {
        id
        title
        activeLocales
        reportActiveLocales
        abilities
        feedbackTemplateId
        inviteTemplateId
        thankYouTemplateId
        reminderTemplateId
        createdBy {
          id
          firstName
          lastName
          email
        }
        createdOn
        updatedOn
      }
      surveyCompetencies {
        id
        displayName
        abilities {
          id
          displayName
        }
      }
      communicationTemplates(first: $first) {
        edges {
          node {
            id
            name
            type
          }
        }
      }
    }
  }
`;

const DetailContainer = (props) => {
  const currentAccount = useContext(AccountContext);
  const growl = useContext(NotificationContext);
  const { templateId } = useParams();
  const variables = {
    accountId: currentAccount,
    tempId: templateId,
    first: 200,
  };

  return (
    <Query query={SURVEY_TEMPLATE_QUERY} variables={variables}>
      {({ loading, error, data }) => {
        if (loading) {
          return <Loading />;
        }
        if (error) {
          growlErrors(growl, error);
          return `Error! ${error.message}`;
        }

        const { account } = data;

        return <Detail data={account} />;
      }}
    </Query>
  );
};

export default DetailContainer;
